import React from 'react';

export interface VideoFormatType {
  maxWidth: number;
  maxHeight: number;
  supportedMimeTypes: string[];
  supportedVideoCodecs: RegExp[];
  supportedAudioCodecs: string[];
}

export const VALID_VIDEO_FORMATS: VideoFormatType = {
  maxWidth: 1920,
  maxHeight: 1080,
  supportedMimeTypes: ['video/mp4'],
  supportedVideoCodecs: [
    /^avc1\.42/, // Baseline
    /^avc1\.4d/, // Main
    /^avc1\.64/, // High
    /^avc1\.6e/, // High 10
    /^avc1\.7a/, // High 4:2:2
    /^avc1\.f4/, // High 4:4:4
  ],
  supportedAudioCodecs: ['mp4a.40.2', 'mp4a.40.5'],
};

export const VIDEO_CONVERSION_GUIDE_URL =
  'https://help.openlearning.com/t/h7hq9mx/how-to-convert-your-video-to-the-right-format-for-faster-upload';

export const VIDEO_THUMBNAIL_MAX_WIDTH = 570;

export const VIDEO_TRANSCODE_ERROR_TITLE = 'Video format not supported';
export const VIDEO_TRANSCODE_ERROR_DESCRIPTION = (
  <span>
    This could mean that your video file is corrupted or of an old format. Learn
    more about how to format your videos from this{' '}
    <a
      href={VIDEO_CONVERSION_GUIDE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      help article
    </a>
    .
  </span>
);

export const FILE_WHITELIST_GUIDE_URL =
  'https://help.openlearning.com/t/60h6kj3';
export const FILE_EXTENSION_ERROR_TITLE = 'File extension not supported';
export const FILE_EXTENSION_ERROR_DESCRIPTION = (
  <span>
    This could mean that your file extension is not supported. Learn more about
    the file extension whitelist from this{' '}
    <a
      href={FILE_WHITELIST_GUIDE_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      help article
    </a>
    .
  </span>
);
